/* eslint-disable no-param-reassign */
/* eslint-disable fp/no-mutation */
import {createSlice} from '@reduxjs/toolkit';

export const timerSlice = createSlice({
  name: 'timer',
  initialState: {
    time: 0,
    isRunning: false,
    isFinished: false,
    label: 'Resend in',
  },
  reducers: {
    setTime: (state, {payload}) => ({
      ...state,
      time: payload * 60,
    }),
    startTimer: state => {
      if (state.time > 0) {
        state.isRunning = true;
      }
    },
    pauseTimer: state => {
      state.isRunning = false;
    },
    resetTimer: state => {
      state.time = 0;
      state.isRunning = false;
      state.isFinished = false;
    },
    timerTick: state => {
      if (state.isRunning && state.time > 0) {
        state.time -= 1;
        if (state.time === 0) {
          state.isRunning = false;
          state.isFinished = true;
        }
      }
    },
  },
});

export const timerState = state => state.timer;

export const {setTime, startTimer, pauseTimer, resetTimer, timerTick} =
  timerSlice.actions;

export default timerSlice.reducer;
